<script>
  import { displayTimeAgo } from 'components/Helper.js';
  import { navigate } from 'svelte-routing';
  export let message;
  export let timeAgoStr;
  export let url = '';
  import { unreadCount } from '../../stores/unreadCount';
  import { client } from 'root/api/index.js';
  import { getContext, onDestroy, onMount } from 'svelte';
  export let item;
  const confirmDraftStatus = getContext('confirmDraftStatus');
  // let tooltipElements;
  // import  {Alert,Button,Carousel ,Collapse ,Dropdown,Tab,Modal,Popover,ScrollSpy,Toast,Tooltip} from 'bootstrap';
  // onMount(()=>{
  //     new Popover(el, {container: el.parentElement,animation: false})
  // })
  import * as bootstrap from 'bootstrap';
  let tooltipTriggerEl, tooltipTriggerElParent;
  let tooltipEl;
  onMount(() => {
    if (tooltipTriggerEl) {
      tooltipEl = new bootstrap.Tooltip(tooltipTriggerEl, {
        delay: 100,
        html: true,
      });
    }
  });
  onDestroy(() => {
    if (tooltipTriggerEl) {
      tooltipEl.hide();
    }
  });
</script>

<li
  class="feeds_li"
  bind:this={tooltipTriggerElParent}
>
  <button
    class="border-0 w-100 bg-transparent shadow-none d-flex flex-row d-flex flex-row align-items-center"
    on:click={() => {
      if (url != null && url.trim() != '') {
        confirmDraftStatus({
          okFunc: () => {
            if (item.read == 0) {
              unreadCount.set($unreadCount - 1);
              client.notificationRead({
                notifications: [{ id: item.notificationUserId }],
              });
            }
            navigate(url);
          },
        });
      }
    }}
  >
    <div
      class="feeds-left me-2 d-flex rounded-circle d-flex align-items-center justify-content-center"
    >
      <img
        alt=""
        src="/images/login_activity.svg"
      />
    </div>
    <div class="feeds-body w-100 d-flex justify-content-between font-size-12">
      <div class="d-flex flex-column">
        <div class="text-muted text-start text-break">
          <span>{@html message}</span>
          {#if item.showTooltip == 1}
            <button
              class="btn btn-link d-inline-block p-0"
              bind:this={tooltipTriggerEl}
              data-bs-placement="bottom"
              title={item.tooltip}
              ><img
                class=" icon-14"
                alt=""
                src="/images/info.svg"
              /></button
            >
          {/if}
        </div>
      </div>
      <small class="text-muted text-nowrap">
        <img
          alt=""
          class="mx-1 icon-10 clock-icon"
          src="/images/clock.svg"
        />
        {timeAgoStr}</small
      >
    </div>
  </button>
</li>

<style lang="scss">
  .feeds_li {
    padding: 8px 15px;
    border-bottom: 1px solid $input-border-color;
    .feeds-left {
      background: rgba($input-border-color, 0.4);
      width: 2rem;
      height: 2rem;
      flex: 0 0 2rem;
    }
  }
</style>
